import { Link, PURPLE_700 } from '@mnd-frontend/ui';
import styled from 'styled-components';

export const BlueLink = styled(Link)`
  color: ${PURPLE_700};

  &:hover,
  &:focus {
    color: ${PURPLE_700};
  }
`;
